import type { NumberSegments } from '../types'

/**
 * Splits a number into its individual segments for animation
 * @param value - The number to split
 * @returns Object containing digits, formatted string, and prefix
 */
export const splitToSegments = (
  value: number | bigint | string,
): NumberSegments => {
  const num = Number(value)
  const isNegative = num < 0
  const integerSegment = Math.abs(Math.floor(num)).toString()
  const formatted = isNegative ? `-${integerSegment}` : integerSegment

  // Convert to digits and generate keys in one pass
  const digits = integerSegment.split('').map((d, i) => ({
    type: 'digit' as const,
    value: parseInt(d, 10),
    // Use reverse index for keys to maintain RTL animation order
    key: `digit:${integerSegment.length - 1 - i}`,
  }))

  // Add negative sign as a separate segment if needed
  const prefix = isNegative
    ? [
        {
          type: 'symbol' as const,
          value: -1, // Special value to indicate negative sign
          key: 'symbol:negative',
        },
      ]
    : []

  return { digits, formatted, prefix }
}
